import React from "react";
import { oneKlicks } from "../../../SDK/oneclick";
import { OneKlicksFileSDK } from "../../../SDK/OneKlicksFileSDK";
import { getuserdata } from "../../../services/apiService";
import { toast } from "react-toastify";
import FileDownload from "./FileDownload";

const Registrations = ({ 
    localRegistrations, 
    setLocalRegistrations, 
    isUploading, 
    setIsUploading, 
    isSaving, 
    setIsSaving, 
    hasChanges, 
    setHasChanges 
}) => {
    const saveRegistrations = async (updatedRegistrations) => {
        setIsSaving(true);
        try {
            const tableSchema = "";
            const tableName = "doctor_registrations";
            const data = {
                registrations: JSON.stringify(updatedRegistrations)
            };
            const condition = {
                id: await getuserdata("id")
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!updateData.success) {
                throw new Error(updateData.error || "Failed to save registrations");
            }
            setHasChanges(false);
            return true;
        } catch (error) {
            console.error("Error saving registrations:", error);
            toast.error(error.message || "Failed to save registrations");
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    const addRegistration = async (e) => {
        e.preventDefault();
        const newRegistration = {
            id: Date.now(),
            registration_number: '',
            file: null,
            file_id: null
        };
        const updatedRegistrations = [...localRegistrations, newRegistration];
        setLocalRegistrations(updatedRegistrations);
        setHasChanges(true);
    };

    const handleRegistrationChange = (index, field, value) => {
        const updatedRegistrations = [...localRegistrations];
        updatedRegistrations[index] = {
            ...updatedRegistrations[index],
            [field]: value
        };
        setLocalRegistrations(updatedRegistrations);
        setHasChanges(true);
    };

    const handleFileUpload = async (index, file) => {
        if (!file) return;

        // Validate file type
        const allowedTypes = [
            'image/jpeg', 'image/jpg', 'image/gif', 'image/png',
            'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-powerpoint', 'text/plain', 'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.error("Please upload a valid file type");
            return;
        }

        // Validate file size (10MB limit)
        if (file.size > 10 * 1024 * 1024) {
            toast.error("File size should be less than 10MB");
            return;
        }

        setIsUploading(true);
        try {
            const root = "doctors/registrations";
            const status = "public";
            
            const uploadedFile = await OneKlicksFileSDK.uploadFile(root, status, file);
            
            if (uploadedFile.success) {
                const updatedRegistrations = [...localRegistrations];
                updatedRegistrations[index] = {
                    ...updatedRegistrations[index],
                    file: file.name,
                    file_id: uploadedFile.fileId
                };
                setLocalRegistrations(updatedRegistrations);
                setHasChanges(true);
                toast.success("File uploaded successfully");
            } else {
                throw new Error(uploadedFile.error || "Failed to upload file");
            }
        } catch (err) {
            console.error("Error uploading file:", err);
            toast.error(err.message || "Failed to upload file");
        } finally {
            setIsUploading(false);
        }
    };

    const deleteRegistration = async (id) => {
        const filteredRegistrations = localRegistrations.filter(reg => reg.id !== id);
        setLocalRegistrations(filteredRegistrations);
        const tableSchema = "";
        const tableName = "doctor_registrations";
        const data = {
            registrations: JSON.stringify(filteredRegistrations)
        };
        const condition = {
            user_id: await getuserdata("id")
        };
        const updatedRegistrations = await oneKlicks.update(tableSchema, tableName, data, condition);
        if (!updatedRegistrations.success) {
            throw new Error(updatedRegistrations.error || "Failed to delete registration");
        }
        setHasChanges(true);
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show">
                <div className="dc-userregistrations dc-tabsinfo">
                    <div className="dc-tabscontenttitle dc-addnew">
                        <h3>Add Your Registrations</h3>
                        <div style={{ float: 'right' }}>
                            <a 
                                href="#" 
                                className="dc-btn dc-btnactive new" 
                                onClick={addRegistration} 
                                style={{ marginRight: '10px' }}
                            >
                                Add New
                            </a>
                        </div>
                    </div>
                    <ul className="dc-registrationsaccordion accordion dc-registrations">
                        {Array.isArray(localRegistrations) && localRegistrations.map((registration, index) => (
                            <li key={registration.id}>
                                <div className="dc-accordioninnertitle">
                                    <span id={`accordioninnertitle${index}`} data-toggle="collapse" data-target={`#innertitle${index}`}>
                                        {registration.registration_number || 'Registration Number'}
                                    </span>
                                    <em>{registration.file || 'No file uploaded'}</em>
                                    <div className="dc-rightarea">
                                        <a className="dc-addinfo dc-skillsaddinfo" id={`accordioninnertitle${index}`} data-toggle="collapse" data-target={`#innertitle${index}`} aria-expanded="true">
                                            <i className="lnr lnr-pencil"></i>
                                        </a>
                                        <a className="dc-deleteinfo" onClick={() => deleteRegistration(registration.id)}>
                                            <i className="lnr lnr-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="dc-collapseexp collapse show" id={`innertitle${index}`} aria-labelledby={`accordioninnertitle${index}`} data-parent="#accordion">
                                    <div className="dc-formtheme dc-userform">
                                        <fieldset>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Registration Number" 
                                                    value={registration.registration_number || ''}
                                                    onChange={(e) => handleRegistrationChange(index, 'registration_number', e.target.value)}
                                                    disabled={isSaving}
                                                />
                                            </div>
                                            {
                                                registration.file_id ? (
                                                    <FileDownload fileid={registration.file_id} filename={registration.file} />
                                                ) : (
                                                    <div className="form-group form-group-half">
                                                <input 
                                                    type="file" 
                                                    className="form-control" 
                                                    onChange={(e) => handleFileUpload(index, e.target.files[0])}
                                                    disabled={isUploading || isSaving}
                                                    accept="image/jpeg,.jpg,.jpeg,image/gif,.gif,image/png,.png,application/pdf,.pdf,application/msword,.doc,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx,application/vnd.ms-powerpoint,.ppt,text/plain,.txt,application/vnd.ms-excel,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx,application/vnd.openxmlformats-officedocument.presentationml.presentation,.pptx"
                                                />
                                                </div>
                                            )}
                                        </fieldset>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Registrations;
